/* eslint-disable max-len */
import React, { useState, useRef, useCallback, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AssosiationList, handleDropdownSelect, setLoading } from './AssociationSlice';
import { GetCommonData } from '../../redux/commonSlice';
import Table from './componnets/Table';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import CardHeader from '../../components/CardHeader';
import { GetBranchId } from '../../CommonMethods/GetBranchId';
import { dataService } from '../../services/data.services';
import Toast from '../../components/Toast';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import moment from 'moment';
import GlobalContext from '../../components/Context/GloablContext';
import { ShimmerTitle } from 'react-shimmer-effects'

export default function ManageAssociation() {
    const location = useLocation()
    const dispatch = useDispatch()
    const Association = useSelector(state => state.Association);
    const [loading, setloading] = useState(true)

    const { year, class_name } = Association.selectedDropdown
    const { common } = useSelector(state => state.CommonData);
    const [searchParams, setSearchParams] = useSearchParams({ page_number: 1 });
    const [academic_year, setAcademicYear] = useState([])
    const [allclasses, setAllClasses] = useState([])
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const {  isInactiveBranch } = useContext(GlobalContext);

    /* The line `const { classes, sections } = common` is destructuring the `classes` and `sections`
    properties from the `common` object. This allows us to directly access these properties without
    having to use `common.classes` and `common.sections`. */
    const { classes,sections } = common

    /* The line `const { selectedDropdown, List } = Association` is destructuring the `selectedDropdown`
    and `List` properties from the `Association` object. This allows us to directly access these
    properties without having to use `Association.selectedDropdown` and `Association.List`. */
    const { selectedDropdown, List } = Association

    const [dropdowns, setdropdowns] = useState('');
    const [initialLoad, setInitialLoad] = useState(true);   
    const [defaultsSet, setDefaultsSet] = useState(false);

    const [ayLoading,setAYLoading] = useState(false)
    const [classLoading,setClassLoading] = useState(false)

    /**
     * The function `handleDropdown` toggles the value of `dropdowns` between an empty string and the
     * provided `key` value.
     * @returns nothing (undefined).
     */
    const handleDropdown = (key) => {
        if (key === dropdowns) {
            setdropdowns('');
            return;
        }
        setdropdowns(key);
    }

    const ref = useRef(null);
    const ref2 = useRef(null);
 
    useOnClickOutside(ref, () => {
        setdropdowns('');
    });

    useOnClickOutside(ref2, () => {
        setdropdowns('');
    });

    /**
     * The function `getAcademicyears` retrieves academic years from an API and sets them in the state.
     */
    const getAcademicyears = async () => {
        try {
            const branch_id = await GetBranchId();
            setAYLoading(true)
            let endpoint = `academic-years?filter=true&branch_id=${branch_id}&status=ongoing,upcoming,completed`;
            const response = await dataService.GetAPI(endpoint);
            const temp = response.data?.data?.data;
            setAcademicYear(temp);

            if(response?.data?.data?.data?.length === 0){
                setloading(false)
                setDefaultsSet(true)
                return;
            }

            // Select the first ongoing academic year if available
            const ongoingYear = temp.find(year => year.status === 'ongoing');
            if (ongoingYear && initialLoad) {
                handleDropdownDispatch('year', ongoingYear);
            }
            setAYLoading(false)

        } catch (error) {
            setAYLoading(false)
            console.error("Error fetching academic years:", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")        }
    };

    const getClasses = async () => {
        setClassLoading(true)
        const branch_id = await GetBranchId()
        let endpoint = `classes?branch_id=${branch_id}&sort=`+encodeURIComponent(`status+asc`);
        const response = await dataService.GetAPI(endpoint);
        const temp = (response.data?.data?.data);
        

        if(response?.data?.data?.data?.length === 0){
            setloading(false)
            setDefaultsSet(true)
            return;
        }

        setAllClasses(temp)    
        setClassLoading(false)
    }

    /**
     * The function `handleDropdownDispatch` handles the dispatching of actions, updates state, and calls
     * the `getAssociation` function based on the selected dropdown values.
     */
    const handleDropdownDispatch = (id, val) => {
        const payload = {
            id, val
        }
        if (val === '') {
            return;
        }
        if (id === 'class_name') {
            if (year._id === undefined || year._id === '') {
                setToastErrorMessage('Select Academic Year and then Class');
                return;
            }
        }
        
        dispatch(handleDropdownSelect(payload));
        handleDropdown(id);
        if (id === 'class_name') {
            setloading(true)

        } else {
            const payload1 = {
                id: 'class_name', val: {}
            }
            if (year._id !== val._id)
                dispatch(handleDropdownSelect(payload1));
        }
        if(id === 'class_name'){
            getAssociation(year._id, val._id)
        }else{
            getAssociation(val._id, class_name._id)
        }
    }

    /* The above code is defining a function called `getAssociation` in JavaScript React. This function is
    using the `useCallback` hook to memoize the function and optimize performance. */
    const getAssociation = useCallback(
        async (yearParam, classParam) => {
            setLoading(true)
            try {
                const id = await GetBranchId();
                const payload = new URLSearchParams(searchParams).toString();
                const ac_year = yearParam || year._id;
                const class_param = classParam || class_name._id;

                if (ac_year === undefined || class_param === undefined) {
                    return;
                } else {
                    const newPayload = {
                        endpoint: `associations?branch_id=${id}&${(payload)}&academic_year_id=${ac_year}&class_id=${class_param}&filter=true`,
                        state: Association.selectedDropdown
                    };
                    dispatch(AssosiationList(newPayload)).then((response) => {
                        setloading(false)
                        setDefaultsSet(true);  
                    })
                }
            } catch (error) {
                // Handle error
                console.error('Error in getAssociation:', error);
                // Optionally, you can set loading to false here as well if needed
                setloading(false);
                setDefaultsSet(true);
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }
        },
        [location],
    );

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    `useEffect` hook is used to fetch common data (such as academic years and classes) from the
    server and store it in the Redux store. */
    useEffect(() => {
        const { id } = GetBranchId();
        getAcademicyears()
        dispatch(GetCommonData(id))
        getClasses(); //to fetch all classes including inactive
    }, [])

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    `useEffect` hook is used to fetch the list of associations based on the selected dropdown values
    (year and class) when the component mounts or when the `getAssociation` function changes. */
    useEffect(() => {
        if (Object.keys(year)?.length > 0 && Object.keys(class_name)?.length > 0) {
            getAssociation()
        } else {
            setloading(false)
        }
    }, [searchParams]);

    useEffect(() => {
        // Select the first class if available when year is selected
        if (academic_year && academic_year.length > 0 && allclasses && allclasses.length > 0 
            && Object.keys(year) && Object.keys(year)?.length > 0 && Object.keys(class_name) 
            && !Object.keys(class_name)?.length && initialLoad) {
            // Filter out disabled classes
            const enabledClasses = allclasses.filter(cls => cls.status);
            if (enabledClasses.length > 0) {
                const firstClass = enabledClasses[0];
                handleDropdownDispatch('class_name', firstClass);
            }

            setInitialLoad(false); // Set the initial load flag to false
        }
        setdropdowns('');
    }, [academic_year, allclasses, year]);

    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setloading(true);
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const isEdit = (Object.keys(year)?.length > 0 && Object.keys(class_name)?.length > 0 && List?.data?.length > 0 && year.status !== 'completed');
    const manageAssociationLink = isEdit
        ? '/employee-master/manage-association/add-association/edit'
        : '/employee-master/manage-association/add-association';

    const isDisabled = !(Object.keys(year)?.length > 0 && Object.keys(class_name)?.length > 0 && year.status !== 'completed' && class_name.status);    
    return (
        <CardHeader
            noPadding
        >
            <div className="mainDataCntnrTop shadow-s13">
                <h5 className="pageHeader">Class Association</h5>
                <div className="flex items-center">
                    <div className="relative w-[237px]" data-te-dropdown-ref>
                        <button ref={ref} onClick={() => handleDropdown('year')} className="sec_filter_btn" type="button" id="acdemic_year"
                            data-te-dropdown-toggle-ref aria-expanded="false" title={Object.keys(year)?.length === 0 ? 'Select Academic year' : year?.name+` (${moment.utc(year.start_date).format("MMM DD, YYYY")}-${moment.utc(year.end_date).format("MMM DD, YYYY")}) (${year.status})`}>
                            <div className='flex'><p className="text-f7 text-[#000000] font-normal more-lines capitalize">{Object.keys(year)?.length === 0 ? 'Select Academic year' : year?.name}</p>{Object.keys(year)?.length !== 0 && <span className='px-1 capitalize'>{"(" + year?.status + ")"}</span>}</div>
                            <img loading="lazy" decoding="async" src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-2 ${dropdowns === 'year' && academic_year?.length > 0 ? "transform rotate-180" : ''}`} />
                        </button>
                        {dropdowns === 'year' && (
                            <ul className="ant-picker-dropdown slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref 
                                style={{'margin-left':'6px'}}
                            >
                                <li className="max-h-[150px] overflow-auto scroll-bar">
                                    {!ayLoading ?
                                        academic_year?.length > 0 ? (academic_year?.map((yearname) => (
                                            <ul key={yearname._id}>
                                                <li onClick={() => handleDropdownDispatch('year', yearname)}>
                                                    <a className={`slct_drp_dwn_optn selected_Class`}
                                                        href="javascript:void(0)" data-te-dropdown-item-ref title={yearname.name + ` (${moment.utc(yearname.start_date).format("MMM DD, YYYY")}-${moment.utc(yearname.end_date).format("MMM DD, YYYY")}) (${yearname.status})`}
                                                    >
                                                        {yearname.name}<span className='capitalize'>{" (" + yearname.status + ")"}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        ))) :
                                            (
                                                <li
                                                    key=""
                                                    id="select-option"
                                                    onClick={(e) => {
                                                        handleDropdownDispatch('year', '');
                                                    }}
                                                >
                                                    <a className="slct_drp_dwn_optn">
                                                        - No options available -
                                                    </a>
                                                </li>
                                            )
                                        : (
                                            <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0rem 0.5rem' }}>
                                                <p className="text-2xl font-bold text-[#031624] mb-4 mt-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                                            </li>
                                        )}
                                </li>
                            </ul>
                        )}
                    </div>
                    <div style={{ "margin-left": "0.375rem" }} className="relative w-[162px]" data-te-dropdown-ref >
                        <button ref={ref2} onClick={() => handleDropdown('class_name')} className="sec_filter_btn"
                            type="button" id="class_name" data-te-dropdown-toggle-ref aria-expanded="false" title={Object.keys(class_name)?.length === 0 ? 'Select Class' : class_name?.name}>
                            <p className="text-f7 text-[#000000] font-normal more-lines">{Object.keys(class_name)?.length === 0 ? 'Select Class' : class_name?.name}</p>
                            <img loading="lazy" decoding="async" src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] ${dropdowns === 'class_name' && allclasses?.length > 0 ? "transform rotate-180" : ''} dropdown-close right-2`} />
                        </button>
                        {dropdowns === 'class_name' && (
                            <ul className="ant-picker-dropdown slct_drp_dwn min-w-full" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref style={{ margin: "0px 7px" }}>
                                <li className="max-h-[150px] overflow-auto scroll-bar">
                                    {!classLoading ?
                                        allclasses?.length > 0 ? (allclasses?.map((val, i) => (
                                            <ul key={val._id}>
                                                <li onClick={() => handleDropdownDispatch('class_name', val)} >
                                                    <a className={`slct_drp_dwn_optn ${val.status ? '' : 'disabled'}`} href="javascript:void(0)"
                                                        title={val.id} data-te-dropdown-item-ref>
                                                        {val.name}
                                                    </a>
                                                </li>
                                            </ul>
                                        ))) :
                                            (
                                                <li
                                                    key=""
                                                    id="select-option"
                                                    onClick={(e) => {
                                                        handleDropdownDispatch('class_name', '')
                                                    }}
                                                >
                                                    <a className="slct_drp_dwn_optn">
                                                        - No options available -
                                                    </a>
                                                </li>
                                            )
                                        : (
                                            <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0rem 0.5rem' }}>
                                                <p className="text-2xl font-bold text-[#031624] mb-4 mt-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                                            </li>)}
                                </li>

                            </ul>
                        )}
                    </div>

                    {!isInactiveBranch &&
                    <div style={{ "margin-left": "0.375rem" }} >
                        <Link
                            id={isEdit?'Edit':'onbaordInstitution'}
                            className={`prmy-btn ${isDisabled ? 'noCursor' : ''}`}
                            to={manageAssociationLink}
                            onClick={(e) => {
                                
                                if (!(Object.keys(year)?.length > 0 && Object.keys(class_name)?.length > 0)) {
                                    e.preventDefault();
                                    setToastErrorMessage("Select AY and Class");
                                    return;
                                }
                                if (year.status === 'completed') {
                                    e.preventDefault();
                                    setToastErrorMessage("AY Completed. Association cannot be added/edited");
                                    return;
                                }
                                if(!class_name.status){
                                    e.preventDefault();
                                    setToastErrorMessage("Class is inactive. Association cannot be added/edited");
                                    return;
                                }
                            }}
                            disabled={isDisabled}
                            style={{"display":"inline-table"}}
                        >
                            Manage Association
                        </Link>
                    </div>}

                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <div className='mainDataCntnrListDiv scrollBlue_thick'>
                {(loading || !defaultsSet) ? <ItemShimmer />
                    :
                    (
                        <Table tableData={List.data}
                            List={List}
                            searchParams={searchParams}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                            isDisabled={isDisabled}
                            isFiltersApplied={Object.keys(year)?.length > 0 && Object.keys(class_name)?.length > 0}
                        />
                    )}
            </div>
        </CardHeader>
    )
}

